import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import '../../../utils/index_orig/index.esm.js';
import '../../../utils/theme/theme-provider/index.esm.js';
import { EGDSBadge } from '../badge/index.esm.js';
import '../floating-dot-notification-badge/index.esm.js';
import '../dot-notification-badge/index.esm.js';
import '../../badge-standard/index.esm.js';
import '../../badge-notifications/index.esm.js';
import '../../badge-loyalty/index.esm.js';
import '../../badge-programs/index.esm.js';
import { EGDSBadgeSize } from '../../types/index.esm.js';
import { classNames } from '../../../utils/classnames/index.esm.js';

/**
 * @deprecated do not use
 */
class EGDSMemberBadge extends React.PureComponent {
  static displayName = 'EGDSMemberBadge';
  render() {
    const {
      className,
      theme,
      ...props
    } = this.props;
    const cssClassNames = classNames(className);
    return jsx(EGDSBadge, {
      ...props,
      size: EGDSBadgeSize.LARGE,
      theme: theme,
      className: cssClassNames
    });
  }
}
export { EGDSMemberBadge };